import bem from 'utils/bem';

export const block = bem('fonts-selector');
